import React, { useState, useEffect, useRef } from "react";
import { FormattedMessage } from 'react-intl';
import Webcam from "react-webcam";
import jsQR from "jsqr";
import PostDataController from '../../Controller/PostDataController.js';

import { withStyles } from '@material-ui/core';
import * as Constants from '../../Pages/Constants';

/************************************
************* WARNING ***************
******** WORKS IN HTTPS ONLY ********
*************************************/

const videoConstraints = {
  width: 540,
  facingMode: "environment"
};

const Camera = (props) => {
  const { classes } = props;
  const webcamRef = useRef(null);
  const [message, setmessage] = useState("");

  const capturePhoto = React.useCallback(async () => {
    const imageSrc = webcamRef.current.getScreenshot();
    if (imageSrc !== null && imageSrc !== undefined && imageSrc !== "") {
      let res = {imageSrc: imageSrc, taker: props.accountInformation.username}
      let current_Date = new Date()                                                                     // Get current date
      current_Date.setMilliseconds(0)
      await PostDataController.post_observation(current_Date, res, "picture", props.id_patient);        // Send data in backend
      props.update(current_Date, JSON.stringify(res));                                                                  // update display
    props.cancelPopup();
    }
    else {
      setmessage(<FormattedMessage id="message.wrongPicture" defaultMessage="Wrong picture" />)
    }
  }, [webcamRef]);

  const onUserMedia = (e) => {
    //console.log(e);
  };

  return (
    <div className={classes.popup_background}>
      <div style={{ width:"75%", height: "100%", display: "flex", flexDirection: "column", justifyContent: "center"}}>
        <div className="submit-form" style={{ borderRadius: "5px"}}>
          <>
            <Webcam
              ref={webcamRef}
              audio={false}
              screenshotFormat="image/jpeg"
              videoConstraints={videoConstraints}
              onUserMedia={onUserMedia}
              width="100%"
            />
          </>
          <b style={{color:"black"}}>{message}</b>
          <br/>
          <button onClick={capturePhoto} className="btn btn-success">
              <FormattedMessage id="account.validationButton" defaultMessage="Submit" />
          </button>
          <button onClick={props.cancelPopup} className="btn btn-danger">
            <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default withStyles(Constants.styles)(Camera);
